module.exports = __webpack_public_path__ + "static/media/curriculum_s3.d1d1d431.png";